import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error-icon',
  templateUrl: './error-icon.component.html',
})

export class ErrorIconComponent {
  @Input() color: string = '';
}
